module.exports = __webpack_public_path__ + "img/lighting-studio_cn.67eabcd.jpg";